import moment from "moment"
import { isEqual, isBefore } from "date-fns"
import * as R from "ramda"

type ISOorTimestamp = number | string

const SECOND = 1000

const mapISOorTimestamp = (x: ISOorTimestamp) => (typeof x === "string" ? x : x * SECOND)
export const mapToUtcMoment = R.compose(moment.utc, mapISOorTimestamp)

export const isSameOrBefore = (date1: Date, date2: Date) =>
  isEqual(date1, date2) || isBefore(date1, date2)

export const getUTCDate = (timestamp: number = Date.now()): Date => {
  const date = new Date(timestamp)

  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  )
}
